import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/page/manage/Index.vue';
import SmallAppMain from '@/page/manage/Main.vue';
import Setting from '@/page/manage/Setting.vue';
import Connection from '@/page/manage/Connection.vue';
import Rights from '@/page/manage/Rights.vue';
import Dev from '@/page/manage/Dev.vue';
import AddMembers from '@/page/manage/AddMembers.vue';
import Payment from '@/page/manage/Payment.vue';
import UpMain from '@/page/upManage/Main.vue';
import Manage from '@/page/upManage/Manage.vue';
import Preview from '@/page/upManage/Preview.vue';
import PayCenter from '@/page/manage/PayCenter.vue';
import Log from '@/page/manage/Log.vue';

let router = {
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            component: Index,
        },
        {
            path: '/payCenter',
            component: PayCenter,
        },
        {
            path: '/app',
            component: SmallAppMain,
            children: [
                {
                    path: 'setting/:appId',
                    component: Setting
                },
                {
                    path: 'upmng/:appId',
                    component: Connection
                },
                {
                    path: 'devmng/:appId',
                    component: Dev
                },
                {
                    path: 'rightsmng/:appId',
                    component: Rights
                },
                {
                    path: 'payment/:appId',
                    component: Payment
                },
                {
                    path: 'log/:appId',
                    component: Log
                }
            ]
        },
        {
            path: '/addmembers/:appId',
            component: AddMembers
        },
        {
            path: '/up',
            component: UpMain,
            children: [
                {
                    path: 'manage',
                    component: Manage
                },
                {
                    path: 'preview',
                    component: Preview
                },
            ]
        }
    ]
};

Vue.use(Router);

export default new Router(router);



// WEBPACK FOOTER //
// ./src/router/index.js